/* Progress bar */
(function () {
  const goal = 299;
  let initialized = false;

  function getPrice() {
    const priceText = document.querySelector('.cart_subtotal')?.textContent || "₪0";
    return parseFloat(priceText.replace(/[^\d.]/g, "")) || 0;
  }

  function getItemCount() {
    // אם יש לך אלמנט שמציג את מספר הפריטים בעגלה - למשל .cart_count
    const itemCountText = document.querySelector('.cart_count')?.textContent || "0";
    return parseInt(itemCountText.replace(/[^\d]/g, ""), 10) || 0;
  }

  function renderProgressBar() {
    const current = getPrice();
    const items = getItemCount();
    const remaining = Math.max(goal - current, 0);

    // אם אין מוצרים → אחוז = 0
    const percent = items === 0 ? 0 : Math.min((current / goal) * 100, 100);

    const target = document.getElementById('mini-cart-shippingbar');
    if (!target) return;

    let wrapper = document.getElementById("progress-wrapper");

    if (!wrapper) {
      wrapper = document.createElement("div");
      wrapper.id = "progress-wrapper";
      wrapper.style.margin = "0 16px";

      // אלמנט לכמות מוצרים
      const itemCountEl = document.createElement("div");
      itemCountEl.id = "cart-item-count";
      itemCountEl.style.textAlign = "right";

      // אלמנט לטקסט ההודעה
      const message = document.createElement("div");
      message.id = "shipping-message";
      message.style.marginBottom = "16px";
      message.style.lineHeight = "14px";
      message.style.textAlign = "right";

      const barContainer = document.createElement("div");
      barContainer.style.backgroundColor = "#eee";
      barContainer.style.borderRadius = "20px";
      barContainer.style.border = "1px solid #012939";
      barContainer.style.height = "14px";
      barContainer.style.position = "relative";

      const bar = document.createElement("div");
      bar.className = "gift-bar";
      bar.style.backgroundColor = "#012939";
      bar.style.height = "100%";
      bar.style.borderRadius = "20px";
      bar.style.transition = "width 0.3s";

      barContainer.appendChild(bar);
      wrapper.appendChild(itemCountEl);
      wrapper.appendChild(message);
      wrapper.appendChild(barContainer);

      target.parentElement.insertBefore(wrapper, target);
    }

    // עדכון כמות מוצרים
    const itemCountEl = wrapper.querySelector("#cart-item-count");
    if (items > 0) {
      itemCountEl.innerHTML = `${items} פריט${items > 1 ? "ים" : ""}`;
    } else {
      itemCountEl.innerHTML = `נותרו לך עוד ₪${remaining.toFixed(2)} למשלוח לנקודת איסוף <span style="font-family: 'NarkissBlock-Bold';">חינם</span>`;
    }

    // עדכון טקסט משלוח
    const message = wrapper.querySelector("#shipping-message");
    if (items === 0) {
      message.innerHTML  = "";
    } else if (remaining > 0) {
      message.innerHTML = `נותרו לך עוד ₪${remaining.toFixed(2)} למשלוח לנקודת איסוף <span style="font-family: 'NarkissBlock-Bold';">חינם</span>`;
    } else {
      message.innerHTML = `קיבלת משלוח לנקודת איסוף בחינם!`;
    }

    // עדכון פרוגרס בר
    const bar = wrapper.querySelector(".gift-bar");
    if (bar) bar.style.width = `${percent}%`;
  }

  function observeCartSubtotal() {
    if (initialized) return; // למנוע כפילות
    initialized = true;

    const subtotalEl = document.querySelector('.cart_subtotal');
    if (!subtotalEl) return;

    console.log("✅ התחברנו ל־.cart_subtotal");

    let timeout;
    const priceObserver = new MutationObserver(() => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        renderProgressBar();
      }, 100);
    });

    priceObserver.observe(subtotalEl, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('.cart_subtotal')) {
      observeCartSubtotal();
      renderProgressBar();
    }
  });

  // --- 🎯 AJAX Hook ל־fetch ---
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    if (args[0].toString().includes("/cart")) {
      setTimeout(renderProgressBar, 200);
    }
    return response;
  };

  // --- 🎯 AJAX Hook ל־XMLHttpRequest ---
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.addEventListener("load", function () {
      if (url.includes("/cart")) {
        setTimeout(renderProgressBar, 200);
      }
    });
    return origOpen.call(this, method, url, ...rest);
  };
})();

 /* END Progress bar */



$(".sidebar-block__heading").click(function(){
    $(this).find("span").html($(this).find("span").html() == '+' ? '-' : '+');
}); 

if ($(window).width() > 798) {
      if ($('.header').hasClass('header-fixed--true')){
        if (!$('.main-nav__wrapper').hasClass('sticky_nav')) {
          $( window ).scroll(function() {
            if ($(this).scrollTop() > 250) {
            //$( ".sticky_nav--stick .header__logo" ).hide();
            $( ".sticky_login" ).show();
            $( ".sticky_search" ).show();
            $( ".sticky_try-here-btn" ).show();
            $( ".sticky_try-here2-btn" ).show();
            $( ".sticky_logo" ).show();
            $( ".menu" ).addClass('sticky_menu')
            $( ".sticky_login" ).addClass('sticky_login-align');
            $( ".mini_cart" ).addClass('sticky_cart-align');
            }
            if($(this).scrollTop() < 250){
              //$( ".sticky_nav--stick .header__logo" ).show();
              $( ".sticky_login" ).hide();
              $( ".sticky_search" ).hide();
              $( ".sticky_try-here-btn" ).hide();
              $( ".sticky_try-here2-btn" ).hide();
              $( ".sticky_logo" ).hide();
              $( ".menu" ).removeClass('sticky_menu');
              $( ".sticky_login" ).removeClass('sticky_login-align');
              $( ".mini_cart" ).removeClass('sticky_cart-align');
            }
          });
        }
      }
    }

$(".mobile-filter-btn").on("click", function(){
	$(".sidebar").slideDown();
});

$('.collection-filter-close').on("click", function(){
	$('.sidebar').slideUp();
});

/* solution page */
$('.argania-tab1').on('click', function(){
	$('.argania-content1').slideToggle();
});
$('.argania-tab2').on('click', function(){
	$('.argania-content2').slideToggle();
});
$('.argania-tab3').on('click', function(){
	$('.argania-content3').slideToggle();
});
$('.argania-tab4').on('click', function(){
	$('.argania-content4').slideToggle();
});

$('.comprehensive-tab1').on('click', function(){
	$('.comprehensive-content1').slideToggle();
});
$('.comprehensive-tab2').on('click', function(){
	$('.comprehensive-content2').slideToggle();
});
$('.comprehensive-tab3').on('click', function(){
	$('.comprehensive-content3').slideToggle();
});

$('.formulated-tab1').on('click', function(){
	$('.formulated-content1').slideToggle();
});

$('.runners-face-tab1').on('click', function(){
	$('.runners-face-content1').slideToggle();
});
$('.runners-face-tab2').on('click', function(){
	$('.runners-face-content2').slideToggle();
});
$('.runners-face-tab3').on('click', function(){
	$('.runners-face-content3').slideToggle();
});
$('.runners-face-tab4').on('click', function(){
	$('.runners-face-content4').slideToggle();
});
$('.runners-face-tab5').on('click', function(){
	$('.runners-face-content5').slideToggle();
});
$('.runners-face-tab6').on('click', function(){
	$('.runners-face-content6').slideToggle();
});
$('.runners-face-tab7').on('click', function(){
	$('.runners-face-content7').slideToggle();
});


   $(document).ready(function(){
        $(".argania-tab1").click(function(){
            $('.argania-tab1 span').html($('.argania-tab1 span').html() == '+' ? '-' : '+');
        });
        $(".argania-tab2").click(function(){
            $('.argania-tab2 span').html($('.argania-tab2 span').html() == '+' ? '-' : '+');
        });
        $(".argania-tab3").click(function(){
            $('.argania-tab3 span').html($('.argania-tab3 span').html() == '+' ? '-' : '+');
        });
        $(".argania-tab4").click(function(){
            $('.argania-tab4 span').html($('.argania-tab4 span').html() == '+' ? '-' : '+');
        });
     
        $(".comprehensive-tab1").click(function(){
            $('.comprehensive-tab1 span').html($('.comprehensive-tab1 span').html() == '+' ? '-' : '+');
        });
        $(".comprehensive-tab2").click(function(){
            $('.comprehensive-tab2 span').html($('.comprehensive-tab2 span').html() == '+' ? '-' : '+');
        });
        $(".comprehensive-tab3").click(function(){
            $('.comprehensive-tab3 span').html($('.comprehensive-tab3 span').html() == '+' ? '-' : '+');
        });
     
         $(".formulated-tab1").click(function(){
            $('.formulated-tab1 span').html($('.formulated-tab1 span').html() == '+' ? '-' : '+');
        }); 
     
     	$(".runners-face-tab1").click(function(){
            $('.runners-face-tab1 span').html($('.runners-face-tab1 span').html() == '+' ? '-' : '+');
        });
        $(".runners-face-tab2").click(function(){
            $('.runners-face-tab2 span').html($('.runners-face-tab2 span').html() == '+' ? '-' : '+');
        });
        $(".runners-face-tab3").click(function(){
            $('.runners-face-tab3 span').html($('.runners-face-tab3 span').html() == '+' ? '-' : '+');
        });
        $(".runners-face-tab4").click(function(){
            $('.runners-face-tab4 span').html($('.runners-face-tab4 span').html() == '+' ? '-' : '+');
        });
        $(".runners-face-tab5").click(function(){
            $('.runners-face-tab5 span').html($('.runners-face-tab5 span').html() == '+' ? '-' : '+');
        });
        $(".runners-face-tab6").click(function(){
            $('.runners-face-tab6 span').html($('.runners-face-tab6 span').html() == '+' ? '-' : '+');
        });
     	$(".runners-face-tab7").click(function(){
            $('.runners-face-tab7 span').html($('.runners-face-tab7 span').html() == '+' ? '-' : '+');
        });

        $(".step2-q1").click(function(){
            $('.step2-q1 span').html($('.step2-q1 span').html() == '-' ? '+' : '-');
        });

        $(".step2-q2").click(function(){
            $('.step2-q2 span').html($('.step2-q2 span').html() == '+' ? '-' : '+');
        });

        $(".step2-q3").click(function(){
            $('.step2-q3 span').html($('.step2-q3 span').html() == '+' ? '-' : '+');
        });

        $(".step2-q4").click(function(){
            $('.step2-q4 span').html($('.step2-q4 span').html() == '+' ? '-' : '+');
        });

        $(".step2-q5").click(function(){
            $('.step2-q5 span').html($('.step2-q5 span').html() == '+' ? '-' : '+');
        });

        $(".step2-q6").click(function(){
            $('.step2-q6 span').html($('.step2-q6 span').html() == '+' ? '-' : '+');
        });
     
		/*$(".collection-sidebar-open").click(function(){
            $(this).toggleClass("collection-sidebar-close");
        });*/

     
/* Product page mobile version */
     
$('.how-to-use-tab').on('click', function(){
  $('.how-to-use-content').slideToggle();
  $('.how-to-use-tab span').html($('.how-to-use-tab span').html() == '-' ? '+' : '-');
});


$('.ingredients-tab').on('click', function(){
  $('.ingredients-content').slideToggle();
  $('.ingredients-tab span').html($('.ingredients-tab span').html() == '-' ? '+' : '-');
});

/* END Product page mobile version */

    $('.read-more').on('click', function(){
	$('.read-more-content').slideToggle();
  	$('.read-more').html($('.read-more').html() == 'קראי עוד' ? 'קראי פחות' : 'קראי עוד');
});

     /* c me step 2 FAQ */

$('.step2-q1').on('click', function(){
  console.log('1');
	$('.step2-a1').slideToggle();
});
$('.step2-q2').on('click', function(){
	$('.step2-a2').slideToggle();
});
$('.step2-q3').on('click', function(){
	$('.step2-a3').slideToggle();
});
$('.step2-q4').on('click', function(){
	$('.step2-a4').slideToggle();
});
$('.step2-q5').on('click', function(){
	$('.step2-a5').slideToggle();
});
$('.step2-q6').on('click', function(){
	$('.step2-a6').slideToggle();
});  

/* Account page - complete details */



/* END Account page - complete details */

    });

/* GLOW ME + LP SLIDESHOW */

let slideIndex = 1;
showSlides(slideIndex);

// Next/previous controls
function plusSlides(n) {
  showSlides(slideIndex += n);
}

// Thumbnail image controls
function currentSlide(n) {
  showSlides(slideIndex = n);
}

function showSlides(n) {
  let i;
  let slides = document.getElementsByClassName("mySlides");
  let dots = document.getElementsByClassName("dot");
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" active", "");
  }
  slides[slideIndex-1].style.display = "block";
  dots[slideIndex-1].className += " active";
}
/* END GLOW ME + LP SLIDESHOW */

